import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCarDescription } from 'ctm-components/components/utils';
import { getColourLabel, getLabelFromCode } from '../../../core/state_selectors';
import { SummaryTable } from '../summary_table';

const path = 'car_make';

const _SummaryCarDetails = (props) => {
    const { make, year, model, body, transmission, fuel, colour, isUpdated, series } = props;
    const descriptions = series.at(0)?.descriptions;
    const carDetails = [
        {
            title: 'Car make',
            value: make
        },
        {
            title: 'Year model',
            value: year
        },
        {
            title: 'Car model',
            value: model
        },
        {
            title: 'Body type',
            value: body
        },
        {
            title: 'Transmission',
            value: transmission
        },
        {
            title: 'Fuel type',
            value: fuel
        },
        {
            title: 'Description',
            value: getCarDescription(descriptions)
        },
        {
            title: 'Colour',
            value: colour
        }
    ];

    return (
        <SummaryTable
            path={path}
            isUpdated={isUpdated}
            titleLabel={`Car Details ${isUpdated ? '- Updated' : ''}`}
            tableContent={carDetails}
        />
    );
};

const mapStateToProps = (state) => {
    const make  = getLabelFromCode(state, 'coverDetail.vehicle.make', 'vertical.quote.apiResponses.makes');
    const year  = getLabelFromCode(state, 'coverDetail.vehicle.year', 'vertical.quote.apiResponses.years');
    const model  = getLabelFromCode(state, 'coverDetail.vehicle.model', 'vertical.quote.apiResponses.models');
    const body  = getLabelFromCode(state, 'coverDetail.vehicle.body', 'vertical.quote.apiResponses.bodies');
    const badge = getLabelFromCode(state, 'coverDetails.vehicle.badge', 'vertical.quote.apiResponses.badge');
    const transmission  = getLabelFromCode(state, 'coverDetail.vehicle.transmission', 'vertical.quote.apiResponses.transmissions');
    const fuel  = getLabelFromCode(state, 'coverDetail.vehicle.fuel', 'vertical.quote.apiResponses.fuel');
    const colour  = getLabelFromCode(state, 'coverDetail.vehicle.colour', 'vertical.quote.apiResponses.colours');
    const isUpdated = state.getIn(['vertical', 'quote', 'form', `summaryPageEdit${path}`]);
    const series = state.getIn(['vertical', 'quote', 'apiResponses', 'series']).toJS() || [];
    return {
        make, year, model, body, transmission, fuel, colour, isUpdated, series
    };
};

_SummaryCarDetails.propTypes = {
    make: PropTypes.string,
    year: PropTypes.string,
    model: PropTypes.string,
    body: PropTypes.string,
    transmission: PropTypes.string,
    fuel: PropTypes.string,
    colour: PropTypes.string,
    isUpdated: PropTypes.bool,
    series: PropTypes.array
};

const SummaryCarDetails = connect(
    mapStateToProps,
)(_SummaryCarDetails);

export { _SummaryCarDetails, SummaryCarDetails };
